// src/components/About.js
import React, { useState, useEffect } from 'react';
import './About.css';

// Importa tus imágenes locales
import imagen1 from '../images/campo1.jpeg';
import imagen2 from '../images/campo2.jpeg';
import imagen3 from '../images/campo3.jpeg';
import imagen4 from '../images/campo4.jpeg';

function About() {
  const images = [imagen1, imagen2, imagen3, imagen4];
  const [activeIndex, setActiveIndex] = useState(0);

  // Función para avanzar al siguiente slide
  const nextSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  // Función para retroceder al slide anterior
  const prevSlide = () => {
    setActiveIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  // Configurar el cambio automático
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Cambia cada 5 segundos

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(interval);
  }, [activeIndex]); // Se reinicia cuando activeIndex cambia

  return (
    <section id="nosotros" className="about-section">
      <div className="container">
        <h2 className="section-title">Sobre OLPEAL</h2>
        <div className="row align-items-center">
          
          {/* Carrusel automático */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="auto-carousel">
              <div className="carousel-wrapper">
                {/* Contenedor de slides */}
                <div className="carousel-slides-container">
                  {images.map((image, index) => (
                    <div 
                      key={index}
                      className={`carousel-slide ${index === activeIndex ? 'active' : ''}`}
                      style={{ backgroundImage: `url(${image})` }}
                    >
                      {/* La imagen se muestra como fondo para mantener proporciones */}
                    </div>
                  ))}
                </div>
                
                {/* Controles de navegación */}
                <button 
                  className="carousel-nav prev" 
                  onClick={prevSlide}
                  aria-label="Imagen anterior"
                >
                  <i className="fas fa-chevron-left"></i>
                </button>
                
                <button 
                  className="carousel-nav next" 
                  onClick={nextSlide}
                  aria-label="Siguiente imagen"
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
                
                {/* Indicadores de posición (puntos) */}
                <div className="carousel-dots">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
                      onClick={() => setActiveIndex(index)}
                      aria-label={`Ir a imagen ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          
          {/* Texto */}
          <div className="col-lg-6">
            <div className="about-text-content">
              <h3 className="mb-3">Pasión por la agricultura sostenible</h3>
              <p className="mb-3">
                Fundada con el objetivo de producir alimentos de la más alta calidad, OLPEAL combina 
                tradición agrícola con innovación tecnológica en el cultivo de olivos, pecanes y almendros.
              </p>
              <p className="mb-4">
                Nuestros campos están ubicados en regiones con condiciones climáticas ideales para cada 
                cultivo, asegurando productos con el mejor sabor y propiedades nutritivas.
              </p>
              
              <div className="about-highlights">
                <div className="highlight-item">
                  <i className="fas fa-leaf highlight-icon"></i>
                  <span>Cultivos 100% naturales</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-tint highlight-icon"></i>
                  <span>Técnicas sostenibles</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-award highlight-icon"></i>
                  <span>Calidad certificada</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-recycle highlight-icon"></i>
                  <span>Compromiso ambiental</span>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default About;